import PropTypes from 'prop-types'
import React from 'react'
import Spinner from './Spinner'
import SingleElement from './SingleElement'

const LOADER_COMPONENTS = {
  'ios': Spinner,
}

const propTypes = {
  type: PropTypes.oneOf(['spin', 'comet', 'pulse', 'ios']),
}

export function Loader ({ type: _type, ...props }) {
  if (_type in LOADER_COMPONENTS) {
    return React.createElement(LOADER_COMPONENTS[_type], props)
  }

  return <SingleElement type={_type} {...props} />
}

Loader.propTypes = propTypes

export default Loader
